import { useMutation } from '@gogame/query';

import { createMasterCampaign } from 'scenes/Influencers/MasterCampaigns/sources/masterCampaigns';

import { create } from '../queryKeyFactory';

export const useCreateMasterCampaign = () => {
  const createMutation = useMutation(create(), createMasterCampaign, {
    successMessage: () => {
      return `Master Campaign created`;
    },
  });
  return [createMutation.mutateAsync, createMutation];
};
